import { type ApiResponse, type SalesforceMapping } from '@types';
import { microServicesRoutes } from '@constants';
import { syncApi } from '@lib/apiClients.ts';
import { handleError } from '@utils/handleAPIError.ts';

export function SalesforceDispositionsApi (): {
  getSalesforceMappingsByOrgId: (
    organizationId: string
  ) => Promise<ApiResponse<SalesforceMapping>>;
  getCallDispositions: (
    organizationId: string,
    nonce: string,
  ) => Promise<ApiResponse<string[]>>;
  saveSalesforceMapping: (
    mappingId: string,
    updateMappingDto: { mapping: string },
  ) => Promise<ApiResponse<SalesforceMapping>>; } {


  async function getSalesforceMappingsByOrgId (organizationId: string):
    Promise<ApiResponse<SalesforceMapping>> {
    try {
      const res = await syncApi.get<SalesforceMapping>(
        `${microServicesRoutes.sync.get.salesforce.getMappings}/${organizationId}`,
      );

      return {
        success: true,
        data: res.data,
      };
    } catch (e) {
      return handleError<SalesforceMapping>('Error trying to get numbers', e, 'Edge getNumbers');
    }
  }

  async function getCallDispositions (
    organizationId: string,
    nonce: string,
  ): Promise<ApiResponse<string[]>> {
    try {
      const res = await syncApi.get<string[]>(
        `${microServicesRoutes.sync.get.salesforce.getCustomDispositions}/${organizationId}/${nonce}`,
      );

      return {
        success: true,
        data: res.data,
      };
    } catch (e) {
      return handleError<string[]>('Error trying to get numbers', e, 'Edge getNumbers');
    }
  }

  async function saveSalesforceMapping (
    mappingId: string,
    updateMappingDto: { mapping: string },
  ):  Promise<ApiResponse<SalesforceMapping>> {
    try {
      const res = await syncApi.post<SalesforceMapping>(
        `${microServicesRoutes.sync.post.salesforce.updateMapping}/${mappingId}`,
        updateMappingDto
      );

      return {
        success: true,
        data: res.data,
      };
    } catch (e) {
      return handleError<SalesforceMapping>('Error trying to get numbers', e, 'Edge getNumbers');
    }
  }

  return {
    getSalesforceMappingsByOrgId,
    getCallDispositions,
    saveSalesforceMapping,
  };
}